import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

// navigations into the metadata page flag freshly started runs
const metadataSearchSchema = z.object({
  newVersion: z.boolean().optional(),
});

export const Route = createFileRoute(
  "/_protected/auditor/clients/$id/_agbw/metadata",
)({
  validateSearch: metadataSearchSchema,
});
